

































import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref,
} from "vue-property-decorator";

import api from "@/api";
import {
  CmsFriendLinkDto,
  CmsFriendLinkCreateOrUpdateDto,
  ResetPasswordDto
} from "@/api/appService";
import { ElForm } from "element-ui/types/form";
import { validStrongPassword } from "@/utils/validate";

@Component({
  name: "ResetPassword",
  components: { },
})
export default class ResetPassword extends Vue {
  @Ref() readonly dataForm!: ElForm;

  @Prop({ required: true })
  dataId!: number;

  defaultData: ResetPasswordDto = {
    newPassword: undefined,
    adminPassword: undefined
  };

  show = false;
  that = this;
  form: ResetPasswordDto = { ...this.defaultData };

  get title() {
    return `重置密码`;
  }

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      const loading = this.$loading({
        target: ".el-dialog",
      });

      this.form = { ...this.defaultData };
      //
      setTimeout(() => {
        loading.close();
      }, 200);
    } else {
      this.form = { ...this.defaultData };
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  async save() {
    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        console.log(this.form)
        debugger
        await api.user.resetPassword({body:{userId:this.dataId,newPassword:this.form.newPassword,adminPassword:this.form.adminPassword}})
        this.show = false;
        this.$message.success("重置成功");
        this.$emit("onSave");
      }
    });
  }

  cancel() {
    this.show = false;
  }

  linkRule = {
    adminPassword: [
      {
        required: true,
        message: "请输入管理员密码",
        trigger: "blur",
      },
    ],
    newPassword: [
      {
        required: true,
        message: "请输入新密码",
        trigger: "blur",
      },
      {
        validator: validStrongPassword,
        trigger: "blur",
      },
    ],
  };
}
